import Styled from 'styled-components';

export const StoreSpecialMsgContainer = Styled.div`
  display: flex;
  align-items: baseline;
  font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
  font-family: ${(props) => props.theme.typography.fonts.secondary};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
     ${(props) => {
       return props.fromStoreSpecialsCarousel && 'margin-top: 6px;';
     }};
    }

`;
export const OfferPrice = Styled.span`
  font-size: 13px;
  font-family: Nunito;
  font-weight: 800;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => {
    return props.brand === 'gym' || props.isBundle
      ? props.theme.colors.PRIMARY.DARK
      : props.theme.colors.NOTIFICATION.ERROR;
  }};
  display: block;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: ${(props) => (props.fromStoreSpecialsCarousel ? '9px' : '11px')};
  }
`;

export const MessageWrapper = Styled.span`
  font-family: Nunito;
  font-size: 13px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  margin-left: 4px;
  color: ${(props) => props.theme.colors.NOTIFICATION.ERROR};

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: ${(props) => (props.fromStoreSpecialsCarousel ? '9px' : '11px')};
  }
`;
